import {
    IconCancelRegular,
    IconCheckedRegular,
    IconSendRegular,
    IconTimeRegular,
    IconWarningRegular,
    Tag,
    Text2,
    skinVars,
} from '@telefonica/mistica';
import { useTranslation } from 'react-i18next';

import './index.scss';

export const OrderStatusTag = ({ status }: { status: string }) => {
    const { t } = useTranslation();

    if (status === 'IN_PROGRESS') {
        return (
            <Tag type='warning' Icon={IconTimeRegular}>
                {t('ordersTagInProgress')}
            </Tag>
        );
    } else if (status === 'CANCELED') {
        return (
            <Tag type='inactive' Icon={IconCancelRegular}>
                {t('ordersTagCancelled')}
            </Tag>
        );
    } else if (status === 'FINISHED') {
        return (
            <Tag type='success' Icon={IconCheckedRegular}>
                {t('ordersTagFinished')}
            </Tag>
        );
    } else if (status === 'INCIDENCE') {
        return (
            <Tag type='error' Icon={IconWarningRegular}>
                {t('ordersTagIncidence')}
            </Tag>
        );
    } else if (status === 'PENDING') {
        return (
            <Tag type='active' Icon={IconSendRegular}>
                {t('ordersTagPending')}
            </Tag>
        );
    } else if (status === 'INITIATED') {
        return (
            <Tag type='active' Icon={IconSendRegular}>
                {t('ordersTagInitiated')}
            </Tag>
        );
    }
    return <></>;
};

export const AppointmentStatusTag = ({ status }: { status: string }) => {
    const { t } = useTranslation();

    if (status === 'UNSCHEDULED') {
        return (
            <div className='tag__text-tagBrand'>
                <Text2 medium color={skinVars.colors.brand}>
                    {t('unscheduledTagSecondary')}
                </Text2>
            </div>
        );
    } else if (status === 'SCHEDULED') {
        return (
            <div className='tag__text-tagWarning'>
                <Text2 medium color={skinVars.colors.warningHigh}>
                    {t('scheduledTagSecondary')}
                </Text2>
            </div>
        );
    } else if (status === 'DONE') {
        return (
            <div className='tag__text-tagSuccess'>
                <Text2 medium color={skinVars.colors.successHigh}>
                    {t('doneTagSecondary')}
                </Text2>
            </div>
        );
    } else if (status === 'EXPIRED') {
        return (
            <div className='tag__text-tagError'>
                <Text2 medium color={skinVars.colors.errorHigh}>
                    {t('expiredTagSecondary')}
                </Text2>
            </div>
        );
    } else if (status === 'CANCELED') {
        return (
            <div className='tag__text-tagInactive'>
                <Text2 medium color={skinVars.colors.neutralMedium}>
                    {t('installationAppointmentSubstatusCanceled')}
                </Text2>
            </div>
        );
    }

    return <></>;
};

export const TrackingStatusTag = ({ status }: { status: string }) => {
    const { t } = useTranslation();

    if (status === 'PENDING') {
        return (
            <div className='tag__text-tagBrand'>
                <Text2 medium color={skinVars.colors.brand}>
                    {t('pendingTagSecondary')}
                </Text2>
            </div>
        );
    } else if (status === 'TRANSIT') {
        return (
            <div className='tag__text-tagWarning'>
                <Text2 medium color={skinVars.colors.warningHigh}>
                    {t('transitTagSecondary')}
                </Text2>
            </div>
        );
    } else if (status === 'DELIVERY') {
        return (
            <div className='tag__text-tagWarning'>
                <Text2 medium color={skinVars.colors.warningHigh}>
                    {t('deliveryTagSecondary')}
                </Text2>
            </div>
        );
    } else if (status === 'DELIVERED') {
        return (
            <div className='tag__text-tagSuccess'>
                <Text2 medium color={skinVars.colors.successHigh}>
                    {t('deliveredTagSecondary')}
                </Text2>
            </div>
        );
    } else if (status === 'FINISH_NO_DELIVERED') {
        return (
            <div className='tag__text-tagError'>
                <Text2 medium color={skinVars.colors.errorHigh}>
                    {t('finishNoDeliveredTagSecondary')}
                </Text2>
            </div>
        );
    } else if (status === 'INCIDENCE') {
        return (
            <div className='tag__text-tagError'>
                <Text2 medium color={skinVars.colors.errorHigh}>
                    {t('incidenceTagSecondary')}
                </Text2>
            </div>
        );
    }
    return <></>;
};
